import PaywallPriceLineText from "./PaywallPriceLineText";
import useConversionFlag from "~/hooks/useConversionFlag";
import {
	CONVERSION_FLAGS,
	isConversionFlagOn,
} from "~/lib/conversion-test-flags";

interface PaywallPriceLineProps {
	className?: string;
}

const PaywallPriceLine = ({ className }: PaywallPriceLineProps) => {
	const { value } = useConversionFlag(CONVERSION_FLAGS.paywallPrice);

	if (!isConversionFlagOn(value)) return null;

	return <PaywallPriceLineText className={className} />;
};

export default PaywallPriceLine;
